import { FC, useEffect } from 'react'

import { Link } from 'react-router-dom'

import { locationEvent, pageViewEvent } from 'src/Helpers/TagManager'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'

import { ForgotPasswordForm } from './components/ForgotPasswordForm'

import { Card, Container, Header, Logo, Text, Wrapper } from './styles'

const logo = '/logo.png'

const ForgotPassword: FC = () => {
  useEffect(() => {
    pageViewEvent({ currentPageInfo: pageInfo.forgotPassword })
    locationEvent()
  }, [])

  return (
    <Wrapper>
      <Container>
        <Logo>
          <img alt='logo' src={logo} width='236' height='52px' />
        </Logo>
        <Card>
          <Header>
            <h3>Forgot your password?</h3>
          </Header>
          <ForgotPasswordForm />
          <Text>
            <Link to='/'>Back to Login</Link>
          </Text>
        </Card>
      </Container>
    </Wrapper>
  )
}

export default ForgotPassword
